import { MATIC_DOCK_UNIT_AMOUNT } from "@/consts/shopify";

type FloorPackageChip = "matic" | "dock";

export type FloorPackageId =
  "one-matic-one-dock" | "one-matic-two-docks" | "two-matics-two-docks";

export type FloorPackage = {
  id: FloorPackageId;
  title: string;
  /** One entry per line; each starts on its own line in the option card. */
  description: readonly string[];
  maticCount: number;
  extraDockCount: number;
  chipGroups: FloorPackageChip[][];
};

export const FLOOR_PACKAGES: readonly [FloorPackage, ...FloorPackage[]] = [
  {
    id: "one-matic-one-dock",
    title: "One Matic, One Dock",
    description: [
      "Perfect for single-level homes.",
      "Carry Matic between floors as needed.",
    ],
    maticCount: 1,
    extraDockCount: 0,
    chipGroups: [["matic", "dock"]],
  },
  {
    id: "one-matic-two-docks",
    title: "One Matic, Two Docks",
    description: [
      "Great for multi-level homes.",
      "Keep docks on two floors and carry Matic between them.",
    ],
    maticCount: 1,
    extraDockCount: 1,
    chipGroups: [["matic", "dock"], ["dock"]],
  },
  {
    id: "two-matics-two-docks",
    title: "Two Matics, Two Docks",
    description: [
      "Effortless cleaning across two floors, with a Matic and dock on each.",
    ],
    maticCount: 2,
    extraDockCount: 0,
    chipGroups: [
      ["matic", "dock"],
      ["matic", "dock"],
    ],
  },
];

const FLOOR_PACKAGE_BY_ID = Object.fromEntries(
  FLOOR_PACKAGES.map((floorPackage) => [floorPackage.id, floorPackage]),
) as Record<FloorPackageId, FloorPackage>;

export const getFloorPackagePlan = (id: FloorPackageId) => {
  const floorPackage = FLOOR_PACKAGE_BY_ID[id];

  return {
    maticCount: floorPackage.maticCount,
    dockCount: floorPackage.extraDockCount,
  };
};

export const getFloorPackageNetAmount = (
  id: FloorPackageId,
  maticUnitAmount: number,
) => {
  const floorPackage = FLOOR_PACKAGE_BY_ID[id];

  return (
    floorPackage.maticCount * maticUnitAmount +
    floorPackage.extraDockCount * MATIC_DOCK_UNIT_AMOUNT
  );
};
